// extracted by mini-css-extract-plugin
export var cols = "ProjectIntro-module--cols--1PaMW";
export var left = "ProjectIntro-module--left--22GAv";
export var middle = "ProjectIntro-module--middle--3qCzu";
export var right = "ProjectIntro-module--right--Yd1T8";
export var description = "ProjectIntro-module--description--1R4tj";
export var row = "ProjectIntro-module--row--ftbsA";
export var label = "ProjectIntro-module--label--1HGZy";
export var rowContent = "ProjectIntro-module--rowContent--2ktv4";
export var clientLogosWrapper = "ProjectIntro-module--clientLogosWrapper--GmhGd";
export var clientLogos = "ProjectIntro-module--clientLogos--3TH0z";
export var clientLogo = "ProjectIntro-module--clientLogo--3s5XK";
export var large = "ProjectIntro-module--large--3y3bw";